export default "__VITE_ASSET__fbc64e5e__"